import _ from "lodash";

export default {
    data() {
        return {
            selected: [],
        };
    },
    methods: {
        onRowSelected(items) {
            this.selected = items;
        },
        addSelectionColums(columns) {
            if (this.hasSelection) {
                return [{ key: "_selected", label: "" }, ...columns];
            } else {
                return columns; // no selection column
            }
        },
        doMergeItems() {
            var ids = _.map(this.selected, (o) => o.id);

            const primary_id = ids.shift(); // first one

            this.mergeItems({ id: primary_id, other_ids: ids });
        },
        doDeleteItems() {
            const vm = this;
            _.forEach(this.selected, function (item) {
                vm.deleteItem(item);
            });
        },
    },
    computed: {
        hasSelection() {
            return this.selected.length > 0;
        },
    },
};
